






//@ts-nocheck
import Chart from 'chart.js'
import moment from 'moment'
import { toDCM } from '@/helper'
import { max } from 'd3-array'
import { getAggregates } from '@/services/aggregates'

export default {
    components: {},
    data() {
        return {
            context: null,
            options: ['year', 'month', 'week', 'day', 'hour', 'minute'],
            scope: 'day',
            history: null,
            chart: null,
            loading: false,
            aggregates: null,
            maxValue: null,
            chartLineColo: '#0FD3EE',
            lineWidth: 2,
        }
    },
    computed: {
        intervalMs() {
            let res = 0
            switch (this.scope) {
                case 'year':
                    res = 1000 * 60 * 60 * 24 * 365
                    break
                case 'month':
                    res = 1000 * 60 * 60 * 24 * 30
                    break
                case 'week':
                    res = 1000 * 60 * 60 * 24 * 7
                    break
                case 'day':
                    res = 1000 * 60 * 60 * 24
                    break
                case 'hour':
                    res = 1000 * 60 * 60
                    break
                case 'minute':
                    res = 1000 * 60
                    break
            }
            return res
        },
        intervalSize() {
            let res = 'minute'
            switch (this.scope) {
                case 'year':
                    res = '12m'
                    break
                case 'month':
                    res = '30d'
                    break
                case 'week':
                    res = '7d'
                    break
                case 'day':
                    res = '24h'
                    break
                case 'hour':
                    res = '1h'
                    break
                case 'minute':
                    res = '1m'
                    break
            }
            return res
        },
        intervalFormat() {
            let res = ''
            switch (this.intervalSize) {
                case '30d':
                    res = 'MMM DD'
                    break
                case '7d':
                    res = 'MMM DD'
                    break
                case '24h':
                    res = 'h:mm a'
                    break
                case '1h':
                    res = 'h:mm a'
                    break
                case '1m':
                    res = 'h:mm:ss a'
                    break
            }
            return res
        },
        xAxislabel() {
            let res = ''
            switch (this.scope) {
                case 'year':
                    res = 'month'
                    break
                case 'month':
                    res = 'date'
                    break
                case 'week':
                    res = 'date'
                    break
                case 'day':
                    res = 'time'
                    break
                case 'hour':
                    res = 'time'
                    break
                case 'minute':
                    res = 'time'
                    break
            }
            return res
        },
        maxTicksLimit() {
            let res = 1
            switch (this.scope) {
                case 'year':
                    res = 4
                    break
                case 'month':
                    res = 4
                    break
                case 'week':
                    res = 7
                    break
                case 'day':
                    res = 6
                    break
                case 'hour':
                    res = 5
                    break
                case 'minute':
                    res = 3
                    break
            }
            return res
        },
        yAxesTicksMax() {
            let res = 1
            switch (this.scope) {
                case 'year':
                    res = 100000000000
                    break
                case 'month':
                    res = 100000000000
                    break
                case 'week':
                    res = 20000000000
                    break
                case 'day':
                    res = 10000000
                    break
                case 'hour':
                    res = 1000000
                    break
                case 'minute':
                    res = 1000000
                    break
            }
            return res
        },
        // raw data
        dataX() {
            const rawData = !this.history ? [] : this.history.intervals
            // the last item in the data series will not constitute a full time intergral
            // replace its data with a projection based on the series avg, if necessary
            if (rawData.length > 0) {
                const average = (
                    rawData
                        .map((d) => d.transactionCount)
                        .reduce((acc, c) => acc + c, 0) / rawData.length
                ).toFixed(0)
                const lastValue = rawData[rawData.length - 1].transactionCount
                if (lastValue < average) {
                    rawData[rawData.length - 1].transactionCount = average
                }
            }
            return rawData
        },
        // charted data
        valuesX() {
            return this.dataX.map((d) => {
                return toDCM(d.transactionVolume).toFixed(0)
            })
        },
        // x-axis labels
        labelsX() {
            return this.dataX.map((d) =>
                moment(new Date(d.startTime)).format(this.intervalFormat)
            )
        },
    },
    created() {
        this.updateHistory()
    },
    mounted() {
        Chart.platform.disableCSSInjection = true

        const rootCanvasRef = this.$refs['transaction_graph']
        this.context = rootCanvasRef.getContext('2d')

        const myLineChart = new Chart(this.context, {
            type: 'line',
            data: {
                labels: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                ],
                datasets: [
                    {
                        label: 'ACT',
                        backgroundColor: 'transparent',
                        borderColor: this.chartLineColor,
                        borderWidth: this.lineWidth,
                        pointBackgroundColor: 'transparent',
                        pointBorderColor: 'transparent',
                        pointHoverBackgroundColor: '#e84970',
                        pointHoverBorderColor: '#e84970',
                        data: this.valuesX,
                        lineTension: 0,
                    },
                ],
            },

            options: {
                responsive: true,
                title: {
                    display: false,
                    text: 'DComm Transaction History',
                },
                animation: {
                    duration: 500,
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true,
                },
                scales: {
                    xAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: false,
                            },
                            gridLines: {
                                color: 'transparent',
                            },
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: this.maxTicksLimit,
                                maxRotation: 30,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: false,
                            },
                            type: 'logarithmic',
                            gridLines: {
                                color: 'transparent',
                                zeroLineWidth: 0,
                            },
                            ticks: {
                                callback: function (value) {
                                    const append = '$'
                                    let prepend = ''

                                    switch (value) {
                                        case 1000000000000:
                                            prepend = '1T'
                                            break
                                        case 100000000000:
                                            prepend = '100B'
                                            break
                                        case 10000000000:
                                            prepend = '10B'
                                            break
                                        case 1000000000:
                                            prepend = '1B'
                                            break
                                        case 100000000:
                                            prepend = '100M'
                                            break
                                        case 10000000:
                                            prepend = '10M'
                                            break
                                        case 1000000:
                                            prepend = '1M'
                                            break
                                        case 100000:
                                            prepend = '100K'
                                            break
                                        case 10000:
                                            prepend = '10K'
                                            break
                                        case 1000:
                                            prepend = '1K'
                                            break
                                        case 100:
                                            prepend = '100'
                                            break
                                        case 10:
                                            prepend = '10'
                                            break
                                        case 0:
                                            prepend = '0'
                                            break
                                        default:
                                            prepend = ''
                                    }
                                    return `${append} ` + value + prepend
                                },
                            },
                        },
                    ],
                },
            },
        })

        this.chart = myLineChart
    },
    methods: {
        setScope(val) {
            this.scope = val
            this.updateHistory()
        },
        async updateHistory() {
            this.loading = true
            const res = await getAggregates(this.intervalSize)
            this.history = res
            this.aggregates = res.aggregates
            this.maxValue = max(this.history.intervals, (d) =>
                toDCM(d.transactionVolume)
            )
            this.loading = false
            this.draw()
        },
        roundToNearestInterval(now) {
            let res = 0
            switch (this.scope) {
                case 'year':
                    // round to nearest month
                    res =
                        new moment(now).startOf('month').valueOf() +
                        1000 * 60 * 60 * 24 * 30
                    break
                case 'month':
                    // round to nearest day
                    res =
                        new moment(now).startOf('day').valueOf() +
                        1000 * 60 * 60 * 24
                    break
                case 'week':
                    // round to nearest day
                    res =
                        new moment(now).startOf('day').valueOf() +
                        1000 * 60 * 60 * 24
                    break
                case 'day':
                    // round to nearest hour
                    res =
                        new moment(now).startOf('hour').valueOf() +
                        1000 * 60 * 60
                    break
                case 'hour':
                    // round to nearest minute
                    res =
                        new moment(now).startOf('minute').valueOf() + 1000 * 60
                    break
                case 'minute':
                    // round to nearest second
                    res = new moment(now).startOf('second').valueOf() + 1000
                    break
            }
            return res
        },
        draw() {
            this.clearChart()
            // bind data to chart
            this.chart.options.scales.xAxes[0].ticks.maxTicksLimit = this.maxTicksLimit

            this.valuesX.forEach((d, i) => {
                const label = this.labelsX[i]
                this.chart.data.labels.push(label)
                this.chart.data.datasets.forEach((dataset) => {
                    dataset.data.push(d)
                })
            })

            this.chart.update()
        },
        clearChart() {
            // clear labels
            this.chart.data.labels = []

            // clear data
            this.chart.data.datasets.forEach((dataset) => {
                dataset.data = []
            })

            // reset y-axis
            this.chart.options.scales.yAxes[0].ticks.max =
                this.maxValue > this.yAxesTicksMax
                    ? this.findLocalLogMax(this.maxValue)
                    : this.yAxesTicksMax

            // update
            this.chart.update()
        },
        findLocalLogMax(x) {
            // largest power of 10 smaller than x
            let i = 1
            while (i * 10 < x) i *= 10

            const difference = this.maxValue - i

            // largest power of 10 smaller than diff
            let j = i
            while (j / 10 > difference) j /= 10

            const newMax = i + j
            return newMax
        },
    },
}
